import {
  STEP_ACTIONS,
  STEP_INDUSTRY,
  STEP_LOCATION,
  STEP_NAME,
  STEP_REVENUE,
  STEP_CRM,
} from "../onboardingShared";

/** Answer fields each chat question owns, cleared when the user steps back to it. */
const ANSWER_RESETS = {
  [STEP_INDUSTRY]: { industryInclude: [], otherIndustries: [], otherSelected: false },
  [STEP_LOCATION]: { locations: [] },
  [STEP_REVENUE]: { revenueLowerBound: null, revenueUpperBound: null },
  [STEP_ACTIONS]: { selectedActions: [] },
  [STEP_CRM]: { crmPreference: null },
  [STEP_NAME]: { searchName: "" },
};

/**
 * The step Back returns to.
 *
 * The "Which other industries should we include?" follow-up is not a step of its
 * own — it is `otherMode` inside STEP_INDUSTRY — so backing out of it re-asks the
 * industry question rather than decrementing the step, which would skip industry
 * entirely.
 */
export const resolveBackStep = (step, otherMode) =>
  otherMode ? STEP_INDUSTRY : Math.max(step - 1, STEP_INDUSTRY);

/**
 * Truncate the transcript so it ends with the prompt for `targetStep`, dropping
 * that question's previous answer and everything asked after it.
 */
export const rewindMessages = (messages, targetStep) => {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (
      message.role === "app" &&
      message.kind === "question" &&
      message.step === targetStep
    ) {
      return messages.slice(0, index + 1);
    }
  }
  return messages;
};

/**
 * Drop the answer the re-asked question owns so a revised reply replaces it.
 * Without this the "Other" follow-up merges the new industries into the stale
 * featured selection the user just backed away from.
 */
export const clearAnswersForStep = (answers, targetStep) => ({
  ...answers,
  ...ANSWER_RESETS[targetStep],
});
